var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutPickupBottomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "155px",
    viewBox: "0 0 345 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4:258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.424 26.803L345 26.4337L344.138 0L113.468 7.41619L114.33 33.8499L154.352 32.5575V69.8642H161.535V32.3318L172.167 31.9934V69.8642H179.35V31.7574L326.272 27.0389V157.556H113.847V184.01H344.898V157.566H333.435L333.424 26.803ZM120.887 14.3606L337.191 7.40592L337.591 19.4894L121.277 26.444L120.887 14.3606ZM337.704 176.83H121.021V164.747H337.704V176.83Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.041 129.645H76.2983V155.064H215.041V129.645ZM207.858 147.883H83.4818V136.826H207.858V147.883Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.855 127.132H239.609V101.714H100.855V127.132ZM108.039 108.894H232.425V119.952H108.039V108.894Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2983 99.211H215.041V73.7928H76.2983V99.211ZM83.4818 80.9731H207.858V92.0307H83.4818V80.9731Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9586 18.2928L58.2383 22.636L77.096 47.4512L82.8163 43.108L63.9586 18.2928Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56638 64.3518L1.83594 70.9932L57.1734 93.7239L59.9038 87.0825L4.56638 64.3518Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6808 115.074L-0.0820312 125.391L1.30227 132.437L54.0651 122.119L52.6808 115.074Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3718 152.609L18.0488 177.576L22.5275 183.19L53.8505 158.223L49.3718 152.609Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.445 66.3766L252.744 117.213C252.481 117.762 252.36 118.369 252.394 118.977C252.428 119.585 252.616 120.174 252.939 120.69C253.265 121.211 253.72 121.638 254.259 121.933C254.798 122.227 255.403 122.379 256.018 122.373H283.376V115.192H261.754L283.951 69.5052L277.445 66.3766Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.913 136.446V143.626H291.617L312.469 113.479L306.569 109.397L287.851 136.446H269.913Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.952 44.7408L250.591 79.858L257.532 81.7067L266.893 46.5895L259.952 44.7408Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.354 42.7603L289.594 81.0598L296.555 82.8321L306.315 44.5326L299.354 42.7603Z",
    fill: "#6A6A6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4:258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 345,
    height: 184,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutPickupBottomIcon);
export default __webpack_public_path__ + "static/media/about-pickup-bottom-icon.00c60fcc0d7e5d967a332d10fd368e5f.svg";
export { ForwardRef as ReactComponent };